// extracted by mini-css-extract-plugin
export default {"filters":"FilterList_filters__KFLu9"};